import { useUser } from "../pages/login/UserContextPersistent";

export const usePermission = () => {
  const { state } = useUser();

  const hasPermission = (api_path, action) => {
    if (!state) {
      return false;
    }
    return state.features.some(
      (feature) =>
        (feature.api_path === api_path || api_path === "") &&
        (feature.action === action || action === "")
    );
  };

  return { hasPermission };
};
